<template>
  <div>
    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Available Payment Methods</p>
      </template>
      <template #collapsibleSection>
        <async-loader v-if='userPaymentMethodsLoading'/>
        <div
          v-else-if="hasUserPaymentMethodsByLob"
          container
          class='_ptxs _pbxs'
        >
          <div
            v-for="paymentMethod in userPaymentMethodsByLob"
            :key="paymentMethod.paymentMethodID"
            row
          >
            <div class="_flex">
             <labeled-data label='Payment Type:' :data="paymentMethod.displayPaymentType ? paymentMethod.displayPaymentType.toUpperCase() : paymentMethod.paymentType"/>
             <labeled-data label='Payment Account:' :data='paymentMethod.displayAccountNumber'/>
             <labeled-data
                v-if="paymentMethod.paymentType === 'CREDIT CARD'"
                label='Expiration Date:' :data='displayExpiration(paymentMethod.expirationMonYear)'>
                  <p v-if="isExpiredExpirationMonYear(paymentMethod.expirationMonYear)" class="lips _mb0">{{expired_payment_method}}</p>
                  <p v-if="isExpiringExpirationMonYear(paymentMethod.expirationMonYear)"  class="lips _mb0">{{expiring_payment_method}}</p>
             </labeled-data>
             <labeled-data
                v-else
                label='Expiration Date:' data='N/A'>
             </labeled-data>
             <labeled-data label='Set Up Date:' :data='displaySetupDate(paymentMethod.createDate)'/>
             <labeled-data class="_text-center">
               <div v-if="paymentMethod.defaultInd">
               <p class="color-leaf  _mtxs">Default</p>
             </div>
              <div v-else>
                <async-button
                :executing="updateDefaultPaymentMethodLoading"
                @clicked="updateDefaultPaymentMethod(paymentMethod)"
                class="btn leaf white --sm _mlxs _mtxs"
                >
                Set Default
                </async-button>
             </div>
            </labeled-data>
             <div>
                <async-button
                :executing="deletingUserPaymentMethod"
                @clicked="deleteUserPaymentMethod(paymentMethod)"
                class="btn sun white --sm _mlxs _mtxs"
                >
                Delete
                </async-button>
             </div>
             <!-- <labeled-data label='Added By:' :data='paymentMethod.createUser'/> -->
            </div>
            <hr>
          </div>
        </div>
        <div
          v-else
          container
          class='_ptxs _pbxs _flex justify-center align-center _flex-column'
        >
          <h4>No payment methods are currently available.</h4>
        </div>
        <div container class="_ptxs _pbxs _flex justify-center align-center _flex-column">
          <div class="aggreement-container">
            <app-checkbox
              :value="agreeToTerms"
              @click="toggleAgreement($event)"
              valueKey='agreeToTerms'
              label='' />
            <div class="agreement-text">
              <div class="_mbxs" v-html="add_payment_method_disclaimer_html"></div>
            </div>
          </div>
          <button
            v-if="!cybersourceDetailsLoading && !isInternalUser"
            type="button"
            class="btn sun white --sm"
            @click="onAddPaymentMethod"
            :disabled="!canAddNewPaymentMethod || !agreeToTerms"
            >
            Add Payment Method
          </button>
          <div v-if="!canAddNewPaymentMethod" class="color-lips _mtxs" v-html="add_user_payment_subgroup_required" />
          <div v-if="!canAddNewPaymentMethod && !underPaymentLimit" class="color-lips _mtxs" v-html="maximum_user_payment_help_text" />
          <div v-if="selected.subGroupCk !== '' && !lobId" class="color-lips _mtxs">
            the selected subgroup is not eligible for payments
          </div>  
        </div>
      </template>
    </collapsible-section>
  </div>
</template>

<script>
  import AppCheckbox from '@atoms/Checkbox';
  import AsyncButton from '@molecules/AsyncButton';
  import CollapsibleSection from '@sections/CollapsibleSection';
  import LabeledData from '@molecules/LabeledData';
  import AsyncLoader from '@molecules/AsyncLoader';
  import moment from 'moment';;
  import { computed, onBeforeMount, ref } from '@vue/composition-api';
  import { useStore } from '@vue3shims';
  import { useBilling, useGroupSelector, usePaymentVerbiage } from '@composables';
  export default {
    components: {
      AppCheckbox,
      AsyncLoader,
      AsyncButton,
      LabeledData,
      CollapsibleSection
    },
    props: [
      'onAddPaymentMethod',
      'headers'
    ],
    setup() {
      const store = useStore(); 
      const {
        cybersourceDetailsLoading,
        DELETE_USER_PAYMENT_METHOD,
        deletingUserPaymentMethod,
        hasUserPaymentMethodsByLob,
        lobId,
        updateDefaultPaymentMethodLoading,
        userPaymentMethods,
        userPaymentMethodsByLob,
        userPaymentMethodsLoading,
        UPDATE_DEFAULT_USER_PAYMENT_METHOD,
      } = useBilling();
      const {
        add_payment_method_disclaimer_html,
        add_user_payment_subgroup_required,
        expired_payment_method,
        initPaymentVerbiage,
        max_user_payment_limit,
        maximum_user_payment_help_text,
      } = usePaymentVerbiage();

      const { selected } = useGroupSelector();

      const agreeToTerms = ref(false);
      const canAddNewPaymentMethod = computed(() => {
        return selected.value.subGroupCk !== '' && underPaymentLimit.value;
      });
      const deleteUserPaymentMethod = (paymentMethod) => {
        console.log(`deleteUserPaymentMethod`, paymentMethod);
        DELETE_USER_PAYMENT_METHOD({
          paymentMethodId: paymentMethod.paymentMethodID
        });
      }
      const displayExpiration = (expirationMonYear) => moment(expirationMonYear, 'MM-YYYY').format('MM/YY');
      const displaySetupDate = (createDate) => moment(createDate).format('MM/DD/YYYY');
      const isExpiredExpirationMonYear = (expirationMonYear) => {
        let current = moment(moment().format('MM-YYYY'), 'MM-YYYY');
        let expiration = moment(expirationMonYear, 'MM-YYYY').endOf('month');
        return !!expiration.isBefore(current);
      }
      const isExpiringExpirationMonYear = (expirationMonYear) => {
        let current = moment(new Date(), 'MM-YYYY');
        let expiration = moment(expirationMonYear, 'MM-YYYY').endOf('month');
        let diffMonths = moment.duration(expiration.diff(current)).asMonths();
        return !!(expiration.isSameOrAfter(current) && diffMonths < 2);
      }
      const isInternalUser = computed(() => store.getters['isInternalUser']);
      const toggleAgreement = (toggle) => {
        agreeToTerms.value = toggle;
      }
      const underPaymentLimit = computed(() => {
        if(userPaymentMethods.value) {
          return userPaymentMethods.value.filter(x => x.lobId == lobId.value).length < max_user_payment_limit.value;
        }
        return false;
      });
      const updateDefaultPaymentMethod = (paymentMethod) => {
        UPDATE_DEFAULT_USER_PAYMENT_METHOD({
          paymentMethodId: paymentMethod.paymentMethodID
        });
      }
      onBeforeMount(async () => {
        await initPaymentVerbiage();
      });

      return {
        add_payment_method_disclaimer_html,
        add_user_payment_subgroup_required,
        agreeToTerms,
        canAddNewPaymentMethod,
        cybersourceDetailsLoading,
        deleteUserPaymentMethod,
        deletingUserPaymentMethod,
        displayExpiration,
        displaySetupDate,
        expired_payment_method,
        hasUserPaymentMethodsByLob,
        isExpiredExpirationMonYear,
        isExpiringExpirationMonYear,
        isInternalUser,
        lobId,
        max_user_payment_limit,
        maximum_user_payment_help_text,
        selected,
        toggleAgreement,
        underPaymentLimit,
        updateDefaultPaymentMethod,
        updateDefaultPaymentMethodLoading,
        userPaymentMethods,
        userPaymentMethodsByLob,
        userPaymentMethodsLoading,
      }
    },
  }
</script>
